<template>
  <div class="rounded-small border-outline-variant flex break-inside-avoid flex-col border p-2">
    <h4 class="text-body-medium">{{ question.question.content }}</h4>
    <PerspectiveValueBar
      :perspectives="perspectiveBarEntries"
      :topic-perspectives="topicPerspectives"
      :disable-animation="true"
    />
    <div v-if="labels && labels.length > 0" class="flex flex-row gap-0.5 pt-4">
      <BaseChip
        v-for="label in labels"
        :key="label"
        :label="label"
        :icon="iconForQuestionLabel(label)"
        >{{ $t(`questionLabel.${label}`) }}</BaseChip
      >
    </div>
  </div>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import PerspectiveValueBar from '@/core/components/analytics/question-list/PerspectiveValueBar.vue'
  import BaseChip from '@/core/components/base/chip/BaseChip.vue'
  import {
    iconForQuestionLabel,
    type QuestionLabels,
  } from '@/core/composables/use-question-analysis-new'
  import type { Perspective } from '@/core/models/perspective'
  import { toValueBarPerspectives } from '@/core/models/perspective-analysis'
  import type { QuestionAnalysis } from '@/core/models/surveys-analytics'
  interface Props {
    title: string
    question: QuestionAnalysis
    topicPerspectives: ReadonlyArray<Perspective>
    labels?: QuestionLabels[]
  }
  const props = defineProps<Props>()

  const perspectiveBarEntries = computed(() =>
    toValueBarPerspectives(props.question.perspectives, props.topicPerspectives),
  )
</script>
